var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "componenManagement" },
    [
      _c(
        "vuedraggable",
        _vm._b(
          {
            attrs: { move: _vm.onMove },
            model: {
              value: _vm.data,
              callback: function ($$v) {
                _vm.data = $$v
              },
              expression: "data",
            },
          },
          "vuedraggable",
          _vm.dragOptions,
          false
        ),
        [
          _c(
            "transition-group",
            _vm._l(_vm.data, function (item, ind) {
              return _c(
                "div",
                {
                  key: item.text + ind,
                  class:
                    item.text == "底部导航" || item.text == "悬浮按钮"
                      ? "item delDragitem"
                      : "item",
                },
                [
                  _c("p", [
                    _c("i", {
                      staticClass: "el-icon-s-grid",
                      staticStyle: { "margin-right": "15px" },
                    }),
                    _vm._v(_vm._s(item.text) + "\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-popconfirm",
                    {
                      attrs: {
                        title: "您确定要删除该组件吗?",
                        icon: "el-icon-warning",
                        iconColor: "red",
                      },
                      on: {
                        confirm: function ($event) {
                          return _vm.onConfirms(ind)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-delete-solid",
                        staticStyle: { cursor: "pointer" },
                        attrs: { slot: "reference" },
                        slot: "reference",
                      }),
                    ]
                  ),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }